import { Link } from 'react-router-dom';

import { Feed } from '@/components/stashstr/Feed';
import { timeframeToSince } from '@/hooks/useStashstrFeed';

export default function Frontpage() {
  return (
    <div>
      <h1 className="text-[18px] font-bold text-gray-900 dark:text-gray-100">frontpage</h1>
      <p className="text-[12px] text-gray-500 dark:text-gray-400 mb-3">
        top this week ·{' '}
        <Link to="/top" className="text-[#1a56db] dark:text-[#6ea8fe] hover:underline">
          more filters →
        </Link>
      </p>
      <Feed sort="top" since={timeframeToSince('week')} topMetric="zaps" />
    </div>
  );
}
